import React, { useState } from 'react';

import { colors } from '../../constants';
import { CheckIcon, CloseIcon, EditIcon } from '../../icons';

const InlineForm = ({ initialValue, defaultValue, inputType, onSave }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState(defaultValue || '');

    const handleChange = (e) => setValue(e.target.value);

    const handleSave = () => {
        setIsEditing(false);
        onSave(value);
    };

    const handleQuit = () => setIsEditing(false);

    return (
        <div className="d-flex gap-3 align-items-center">
            {isEditing ? (
                <>
                    <input type={inputType} value={value} onChange={handleChange} />
                    <div className="d-flex gap-1">
                        <button className="btn p-0 me-1 border-0" onClick={handleSave}>
                            <CheckIcon color={colors.aroGreen} size="24" />
                        </button>
                        <button className="btn p-0 me-1 border-0" onClick={handleQuit}>
                            <CloseIcon size="20" />
                        </button>
                    </div>
                </>
            ) : (
                <>
                    <div>{initialValue}</div>
                    <button
                        className="btn p-0 me-1 border-0"
                        onClick={() => setIsEditing(true)}
                    >
                        <EditIcon color={colors.skyfallDark} size="20" />
                    </button>
                </>
            )}
        </div>
    );
};

export default InlineForm;
